import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import isAfter from 'date-fns/is_after'

export default {
  name: 'login',

  data: function () {
    return {
      showLoginBtn: true,
      showLoader: false,
      sizeLoader: '47px',
      colorLoader: '#32a2f9'
    }
  },

  components: {
    ClipLoader
  },

  computed: {},

  methods: {
    
    /**
     *  1. GET /login request
     *  2. 302 Redirect to /auth URL on success
     *  3. GET /auth request
     *  4.1 If User has a session on IdP      => 302 Redirect to app URL with state_token inside querystring
     *  4.2 If User has NOT a session on IdP  => RENDER LOGIN PAGE out of application.
     */
    loginOIDC: function () {
      this.showLoginBtn = false
      this.showLoader = true
      window.location.replace(this.$hostIdp2 + 'v1/ondusapi/oidc/webauth/login')
    },

    /**
     * Store Authorization Object
     * @param queryParams
     */
    getOAuth: function (queryParams) {
      console.log('=> getOAuth', queryParams)
      
      this.$http.post('v1/ondusapi/oidc/webauth/auth',
        {
          'state_token': queryParams.state_token
        },
        {
          credentials: 'include'
        }
      )
        .then(response => {
          if (response) {
            console.log('POST oidc/webauth/auth', response)
            console.log('headers', response.headers)
            console.log('document.cookie', document.cookie)
            if (response && response.body &&
              response.body.access_token &&
              response.body.refresh_token &&
              response.body.expires_in &&
              response.body.state_token) {
              // Store data:
              this.$storeOAuth(response.body)
              // Set refresh timer on root component:
              this.$root.$emit('refreshToken')
              // Push to home
              this.$router.push('home')
            } else {
              this.$manageError('Error: token not found on res.body')
            }
          }
        })
        .catch(err => {
          this.$manageError(err)
        })
    }
  },

  beforeCreate: function () {
    // save user browser language at login
    let lang = navigator.language || navigator.userLanguage
    console.log(lang)
    lang = 'en'
    this.$store.commit('setUserHomeLanguage', lang)
  },

  created: function () {
    console.log('=> login.create')
    if (this.$route.query.state_token && this.$route.query.state_token !== null) {
      console.log('Landing on app after redirect', this.$route.query)
      // Show out spinner and hide login button
      this.showLoginBtn = false
      this.showLoader = true
      // Init app after redirect landing:
      this.getOAuth(this.$route.query)
    } else {
      if (this.$store.getters.getAccessToken && this.$store.getters.getRefreshToken && this.$store.getters.getExpiresIn) {
        console.log('this.$store.getters.getAccessToken', this.$store.getters.getAccessToken)
        // Check if the token has expired or will expire in the next 10 minutes:
        if (isAfter(new Date(), this.$store.getters.getExpiresIn)) {
          console.log('Token is present but has expired/will expire in the next minutes')
          this.loginOIDC()
        } else {
          console.log('Token is present. Expiring at ' + this.$store.getters.getExpiresIn)
          // Set timer on root component:
          this.$root.$emit('refreshToken')
          // push to home
          this.$router.push('home')
        }
      } else {
        // Init app without token.
        console.log('Token is not present.')
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/login/login.js